export default __webpack_public_path__ + "static/media/Employees_Neck Index.eb413917.pdf";